module.exports = __webpack_public_path__ + "static/Grupo 84-9f3528d3bd0135b658549124ec579398.svg";